import React, { useEffect } from 'react';
import Fields from '../component/reactive-render/renderFields';
import PageTitle from '../component/typography/PageTitle';
import { useDispatch, useSelector } from 'react-redux';
import { CHECK_FORM, CREATE_FORM_OBJ } from '../form-store/action-types';

const AdminPage = () => {
  const dispatch = useDispatch();
  const fields = useSelector(({fields}) => fields);
  const config = fields[0];

  useEffect(() => {
    setTimeout(() => dispatch({ type: CHECK_FORM }), 1);
    dispatch({ type: CREATE_FORM_OBJ, payload: config.name });
  }, [dispatch, config.name]);

  return (
    <>
      <PageTitle>{config.title}</PageTitle>
      <form id='sisp-form' className='sisp-admin-form'>
        {config.fields.map((prps, indx) => (
          <Fields key={indx} {...prps} />
        ))}
      </form>
    </>
  );
};

export default AdminPage;
